<ai-ui-manual-assignment [claimType]="'depo_arbitrary_order'"></ai-ui-manual-assignment>